"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMeshGroupings = void 0;
const uuid_1 = require("uuid");
const generateMeshGroupings = (mappings) => {
    const meshes = new Map();
    const loanAccountToMesh = new Map();
    const collateralAccountToMesh = new Map();
    mappings.forEach((mapping) => {
        const { loanAccountNum, collateralAccountNum, collateralAccountType, } = mapping;
        const collaterAccountWithType = `${collateralAccountNum}-${collateralAccountType}`;
        // see if this collateral account has been assigned to a mesh
        const collatAccountMesh = collateralAccountToMesh.get(collaterAccountWithType);
        const loanAccountMesh = loanAccountToMesh.get(loanAccountNum);
        if (collatAccountMesh && loanAccountMesh) {
            // both the collateral account and loan account are already assigned to a mesh
            if (collatAccountMesh.id !== loanAccountMesh.id) {
                // they are in different meshes.
                // we need to merge the two meshes
                const newMesh = {
                    id: (0, uuid_1.v4)(),
                    collateralAccounts: new Set([
                        ...collatAccountMesh.collateralAccounts,
                        ...loanAccountMesh.collateralAccounts,
                    ]),
                    loanAccounts: new Set([
                        ...collatAccountMesh.loanAccounts,
                        ...loanAccountMesh.loanAccounts,
                    ]),
                };
                meshes.delete(collatAccountMesh.id);
                meshes.delete(loanAccountMesh.id);
                meshes.set(newMesh.id, newMesh);
                newMesh.collateralAccounts.forEach((collateralAccount) => {
                    collateralAccountToMesh.set(collateralAccount, newMesh);
                });
                newMesh.loanAccounts.forEach((loanAccount) => {
                    loanAccountToMesh.set(loanAccount, newMesh);
                });
            }
            else {
                // they are already in the same mesh
                // do nothing
            }
        }
        else if (collatAccountMesh) {
            // the collateral account is already assigned to a mesh
            collatAccountMesh.loanAccounts.add(loanAccountNum);
            loanAccountToMesh.set(loanAccountNum, collatAccountMesh);
        }
        else if (loanAccountMesh) {
            // the loan account is already assigned to a mesh
            loanAccountMesh.collateralAccounts.add(collaterAccountWithType);
            collateralAccountToMesh.set(collaterAccountWithType, loanAccountMesh);
        }
        else {
            // neither the collateral account nor the loan account are assigned to a mesh
            const newMesh = {
                id: (0, uuid_1.v4)(),
                collateralAccounts: new Set([collaterAccountWithType]),
                loanAccounts: new Set([loanAccountNum]),
            };
            meshes.set(newMesh.id, newMesh);
            collateralAccountToMesh.set(collaterAccountWithType, newMesh);
            loanAccountToMesh.set(loanAccountNum, newMesh);
        }
    });
    return {
        meshes,
        loanAccountToMesh,
        collateralAccountToMesh,
    };
};
exports.generateMeshGroupings = generateMeshGroupings;
//# sourceMappingURL=Meshes.js.map